import React from 'react';
import toast, { Toaster, ToastBar } from 'react-hot-toast';

/**
 * The app's single <Toaster>.
 *
 * react-hot-toast ships no dismiss control, so a toast could only be waited
 * out — an error you had already read sat there for its full duration, and the
 * long-lived ones (the API-key toast runs 15s) were worse. ToastBar keeps the
 * library's own layout, styling and enter/exit animation; the only change is
 * that the status icon on the left is wrapped in a button, so the circled X
 * people already reach for actually closes the toast. No second control.
 *
 * Loading toasts are the one exception: their icon stays a plain spinner.
 * Those are shown while a wallet signature is in flight and are dismissed by
 * the code that opened them (toast.dismiss('sign-tx') and friends); closing
 * one by hand would hide a request that is still pending.
 */
const AppToaster = () => (
  <Toaster
    position="top-right"
    toastOptions={{
      duration: 4000,
      style: {
        background: '#333',
        color: '#fff',
      },
      success: {
        style: {
          background: '#10b981',
        },
      },
      error: {
        style: {
          background: '#ef4444',
        },
      },
    }}
  >
    {(t) => (
      <ToastBar toast={t}>
        {({ icon, message }) => (
          <>
            {t.type === 'loading' ? (
              icon
            ) : (
              <button
                type="button"
                className="toast-dismiss-icon"
                onClick={() => toast.dismiss(t.id)}
                aria-label="Dismiss notification"
                title="Dismiss"
              >
                {icon}
              </button>
            )}
            {message}
          </>
        )}
      </ToastBar>
    )}
  </Toaster>
);

export default AppToaster;
